import styled from 'styled-components';

export const styledComponentWithExcludedProps = (component: any, excludedProps: Array<string | number | symbol>) =>
    styled(component).withConfig({
        shouldForwardProp: (prop, _defaultValidatorFn) => !excludedProps.includes(prop)
    });
